import * as React from 'react'
import { CallTrackingContextProvider } from './context'
import { CallTrackingSectionContent } from './CallTrackingSectionContent'
import type { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  type: ENTITY_TYPES
  id: number
}

export function CallTrackingSection(props: Props) {
  return (
    <CallTrackingContextProvider>
      <CallTrackingSectionContent {...props} />
    </CallTrackingContextProvider>
  )
}
